// extracted by mini-css-extract-plugin
export var aircallIframe = "_gc-3";
export var fabContainer = "_gc-5";
export var fabRinging = "_gc-6";
export var loadingOverlay = "_gc-4";
export var pulse = "_gc-7";
export var widgetContent = "_gc-2";
export var widgetPanel = "_gc-0";
export var widgetPanelExpanded = "_gc-1";